import { useMemo } from "react";
import { useReduxStore } from "./useReduxStore";

/** True when the active subscription plan is Free. */
export default function useIsFreePlan() {
  const { getState } = useReduxStore();
  const { dashBoardData } = getState("Home") || {};
  const { subscription: authSubscriptions } = getState("AUTH") || {};

  return useMemo(() => {
    const currentSubscription =
      dashBoardData?.subscription ||
      (Array.isArray(authSubscriptions) ? authSubscriptions[0] : null);
    const planName = (currentSubscription?.planId?.name || "Free").toLowerCase();
    return planName === "free";
  }, [dashBoardData?.subscription, authSubscriptions]);
}
